// framework
import React, { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import { animateCSS, ANIMATIONS } from "utils/css";
import { getRandomInArray } from "utils/arrays";
// styles
import styles from "./Player.module.scss";
//constants
import { MESSAGES } from "constants/constants";
import { getCashImage } from "constants/cash";

const ANIMATION_COOLDOWN = 1000; // 1 second cooldown

export default function Player({ className, player, room, side = "left", orientation = "portrait" }) {
    const isPortrait = orientation === "portrait";
    const isOnCooldown = useRef(false);

    const { name, avatar, mdmdData } = player || {};
    const { totalMoney, cashColor } = mdmdData || {};
    const isOut = Number(totalMoney) === 0;
    const isDisconnected = !player?.connected;
    const isLockedIn = mdmdData?.lockedIn;
    const roundSuffix = Number(mdmdData?.furthestRound) > 0 ? ` - Round ${mdmdData.furthestRound}` : "";
    const cashDisplay = `$${Number(totalMoney || 0).toLocaleString("en-US")}`;
    const moneyText = player?.connected ? mdmdData?.waitingToJoin ? "WAITING" : isOut ? `OUT${roundSuffix}` : cashDisplay : "DISCONNECTED";
    const playerId = player?.id;

    const handleAnimateAvatar = useCallback(() => {
        if (isOnCooldown.current) {
            console.log('Animation on cooldown');
            return;
        }

        isOnCooldown.current = true;
        const animation = getRandomInArray(ANIMATIONS);
        console.log(`#avatar-${playerId}`, animation);
        animateCSS(`#avatar-${playerId}`, animation);

        if (room) {
            room?.send(MESSAGES.TO_SERVER.ANIMATE_POTATO, { id: playerId, animation });
        }

        setTimeout(() => {
            isOnCooldown.current = false;
        }, ANIMATION_COOLDOWN);
    }, [room, player]);

    const badgeClasses = [
        className,
        styles.badge,
        isPortrait && styles.portrait,
        isLockedIn && styles.locked,
        isOut && styles.out,
        isDisconnected && styles.disconected,
        side === "right" ? styles.right : styles.left
    ].filter(Boolean).join(' ');

    return (
        <div className={badgeClasses}>
            <div className={styles.avatarWrap} onClick={handleAnimateAvatar} >
                <img className={styles.avatar} src={avatar} alt={`${name} avatar`} id={`avatar-${playerId}`} />
                {isLockedIn && (
                    <span className={styles.lockIcon}>🔒</span>
                )}
            </div>
            <div className={styles.plate}>

                <div className={`${styles.cashChip}`}>
                    <div className={styles.cashMask}>
                        <img src={getCashImage(cashColor, 4, 1)} alt="" aria-hidden className={styles.cashImg} />
                    </div>
                </div>
                <div className={styles.texts}>
                    <div className={styles.name}>
                        {name}
                    </div>
                    <div className={styles.money}>
                        {moneyText}
                    </div>
                </div>
            </div>
        </div>
    );
}

Player.propTypes = {
    player: PropTypes.object,
    room: PropTypes.object,
    side: PropTypes.oneOf(["left", "right"]),
    orientation: PropTypes.oneOf(["portrait", "landscape"])
};